import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import {
  SHADOW_SPREAD_0,
  SHADOW_SPREAD_8,
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/shadow_spread';

import _merge from 'lodash/merge';
import { getElevationStyle, ElevationProps } from 'components/Elevation';
import { getContext } from 'common';
import Styled from './styles';

const ELEVATION_STYLE = {
  display: 'flex',
  flexDirection: 'column' as const,
  maxHeight: '100vh',
  height: '100%'
};

export interface TreeContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** Children, consider using TreeTitle, Tree, TreeFilter, TreeFooter. */
  children: React.ReactNode;
  /** Override the `Elevation` properties. See `Elevation` component for details. */
  elevationProps?: Partial<ElevationProps>;
  /** @ignore */
  style?: React.CSSProperties;
}

/** Container for the parts of the Tree. Any other props will be provided to the root element. */
const TreeContainer = React.forwardRef<HTMLElement, TreeContainerProps>((props: TreeContainerProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    elevationProps,
    style: propsStyle,
    ...otherProps
  } = props;
  const elevationTheme = theme.ELEVATIONS;
  const shadowColor1 = elevationTheme[8].shadowColorOne;
  const shadowColor2 = elevationTheme[8].shadowColorTwo;

  const SHADOW_1 = `${SHADOW_SPREAD_0} ${SHADOW_SPREAD_0} ${SHADOW_SPREAD_8} ${SHADOW_SPREAD_0} ${shadowColor1}`;
  const SHADOW_2 = `${SHADOW_SPREAD_0} ${SHADOW_SPREAD_8} ${SHADOW_SPREAD_8} ${SHADOW_SPREAD_0} ${shadowColor2}`;
  return (
    /** @ts-expect-error, upgrade DnD package, misisng children type */
    <DndProvider backend={HTML5Backend}>
      <Styled.TreeContainer
        ref={ref}
        RTL={RTL}
        {...otherProps}
        style={_merge({}, {
          ...ELEVATION_STYLE,
          ...getElevationStyle(elevationProps),
          boxShadow: `${SHADOW_1}, ${SHADOW_2}`,
        }, propsStyle)}
      >
        {children}
      </Styled.TreeContainer>
    </DndProvider>
  );
}));

TreeContainer.displayName = 'TreeContainer';

TreeContainer.defaultProps = {
  elevationProps: {
    elevationIndex: 0,
    dark: false,
  },
  style: {}
};

export { TreeContainer as default };
